import './StrongRegistrationModal.css';
import { ModalRef } from '../Modal/Modal';
import React, { ReactNode, useCallback, useRef } from 'react';
import {
  StatusOperationEnum,
  useRegistrationCheck,
} from '../../hooks/useRegistrationCheck';
import SignInUpModal from './components/SignInUpModal';
import { OperationType } from '../../models';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../routes/types';
import { useDispatch } from 'react-redux';
import { setOperation } from '../../redux/general/general.actions';

type StrongRegistrationWrapProps = {
  children: ReactNode;
  operationType: OperationType;
  successAction: () => void;
  useDispatchOperationNull?: boolean;
};

export const StrongRegistrationWrap: React.FC<StrongRegistrationWrapProps> = ({
  children,
  successAction,
  operationType,
  useDispatchOperationNull = true,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const signInUpModalRef = useRef<ModalRef>(null);

  const { registrationState: currentStatus } =
    useRegistrationCheck(operationType);

  const openModal = useCallback(() => {
    switch (currentStatus) {
      case StatusOperationEnum.SignInOrUp:
        signInUpModalRef.current?.openModal();
        break;
      case StatusOperationEnum.CompleteProfile:
        history.push(Routes.CompleteUserInfo);
        break;
      case StatusOperationEnum.ConfirmEmail:
        history.push(Routes.ConfirmEmail);
        break;
      case StatusOperationEnum.Nothing:
        useDispatchOperationNull && dispatch(setOperation(null));
        successAction();
        break;
    }
  }, [
    currentStatus,
    dispatch,
    history,
    successAction,
    useDispatchOperationNull,
  ]);

  return (
    <>
      <div onClick={openModal}>{children}</div>
      <SignInUpModal ref={signInUpModalRef} />
    </>
  );
};
